import { Flex, Text } from '@mantine/core';
import { Icon } from '@dealstack/frontend/shared/components/fundament/Icon/Icon.tsx';
import React from 'react';

interface Props {
	text: string;
}

export const FieldInfo = ({ text }: Props) => {
	return (
		<Flex align="center" gap="0.25rem">
			<Icon variant="information" size="md" />
			<Text size="B6Medium">{text}</Text>
		</Flex>
	);
};
